import { render } from "./Calendar.vue?vue&type=template&id=8446e5ac"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
script.render = render

export default script